export default __webpack_public_path__ + "static/media/westfield-plus.inline.caf08666.svg";